export const achievementData = {
    bio : "The illiterate of the 21st century will not be those who cannot read and write, but those who cannot learn, unlearn, and relearn. - Alvin Toffler",
    achievements : [
        {
            id : 1,
            title : '2019 1st winner of mobile apps competition',
            details : 'Mobile apps competition',
            date : 'Jan 28, 2019',
            field : 'developer',
            image : "https://firebasestorage.googleapis.com/v0/b/kotakin-client.appspot.com/o/WhatsApp%20Image%202021-11-12%20at%2004.41.53.jpeg?alt=media&token=700b8135-a2f9-46e9-9687-952c45a7cd3f"
        },
        {
            id : 2,
            title : '2018 1st winner of Web apps competition',
            details : 'Web apps competition',
            date : 'June 28, 2018',
            field : 'developer',
            image : "https://firebasestorage.googleapis.com/v0/b/kotakin-client.appspot.com/o/WhatsApp%20Image%202021-11-12%20at%2004.42.08.jpeg?alt=media&token=e30350c4-8386-4953-831a-c616ec190635"
        },
        {
            id : 3,
            title : '2019 3rd winner of Taekwondo National',
            details : 'Taekwondo National Competition',
            date : '15 oct, 2019',
            field : 'fighter',
            image : "https://firebasestorage.googleapis.com/v0/b/kotakin-client.appspot.com/o/IMG_20200509_071743.jpg?alt=media&token=3e4ca2b7-e945-4704-863d-ebdc83e2fee3sreerag.rajan5@gmail.com"
        },

    ]
}


// Do not remove any fields.
// Leave it blank instead as shown below.

/*

export const achievementData = {
    bio : "",
    achievements : []
}

*/